"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ScenarioMode;

(function (ScenarioMode) {
  ScenarioMode["portfolio"] = "portfolio";
  ScenarioMode["fund"] = "fund";
})(ScenarioMode = exports.ScenarioMode || (exports.ScenarioMode = {}));